import { GetterTree } from 'vuex';
import { IDataState } from './state';

export default {
  location: state => state.location,
  page: state => state.page,
  data: state => state.data,
} as GetterTree<IDataState, any>;
